import { handleApiResponse, notifyInternalMessage } from '@/functions';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IPaymentProvider } from '@/interfaces/paymentProvider.interface';

type TResponseData = IPaymentProvider[];

export const useRequestGetPaymentProviders = () => {

  const { isLoading, isFetching, data, error } = useQuery({
    queryKey: [routes.api.paymentProviders],
    queryFn: ({ queryKey: [_url] }) =>
      apiClient
        .get<TResponseData>(_url as string)
        .then(handleApiResponse)
        .catch(notifyInternalMessage),
    /* Prevent background refetches from silently discarding unsaved toggle state */
    refetchOnWindowFocus: false,
  });

  return ({
    providers: (data as TResponseData) ?? [],
    /* isLoading is true only on the initial fetch (no data yet). isFetching stays true
       during background refetches, which would flash the skeleton on window focus. */
    isLoading,
    isFetching,
    error
  });

};
